import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import { getTextById } from '../../api/text'
import { toAbsoluteUrl } from '../../_metronic/_helpers'
import { Layout } from '../../_metronic/layout'

const TERMS_TEXT_ID = '6ab38f97cd689f25ffcc502d'
const PRIVACY_TEXT_ID = '642c3cdd83cb4c30a0a09859'
const HOME_TEXT_ID = '6aba07d856671162b13c47f6'

export { TERMS_TEXT_ID, PRIVACY_TEXT_ID, HOME_TEXT_ID }

function getLegalHtml(content) {
	if (!content || typeof content !== 'object')
		return ''
	if (typeof content.es === 'string' && content.es.trim())
		return content.es
	const first = Object.values(content).find(
		(value) => typeof value === 'string' && value.trim()
	)
	return first || ''
}

function LegalTextBody({ textId }) {
	const [html, setHtml] = useState('')
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(false)

	useEffect(() => {
		let active = true
		setLoading(true)
		setError(false)
		getTextById(textId)
			.then((res) => {
				if (!active)
					return
				if (res.status === 200) {
					setHtml(getLegalHtml(res.data?.content))
					setLoading(false)
					return
				}
				setError(true)
				setLoading(false)
			})
			.catch(() => {
				if (!active)
					return
				setError(true)
				setLoading(false)
			})
		return () => {
			active = false
		}
	}, [textId])

	if (loading) {
		return (
			<div className="d-flex align-items-center justify-content-center py-20">
				<span className="spinner spinner-primary spinner-lg mr-4" />
				<span className="text-muted font-weight-bold">Cargando...</span>
			</div>
		)
	}

	if (error) {
		return (
			<div className="alert alert-danger" role="alert">
				No se ha podido cargar el texto.
			</div>
		)
	}

	if (!html) {
		return (
			<div className="text-muted">Este texto no tiene contenido.</div>
		)
	}

	return (
		<div
			className="ck-content bg-white rounded p-8"
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	)
}

function PublicLegalShell({ children }) {
	return (
		<div className="d-flex flex-column flex-root bg-white" style={{ minHeight: '100vh' }}>
			<div className="d-flex align-items-center justify-content-between border-bottom px-6 py-4">
				<Link to="/">
					<img
						alt="logo"
						src={toAbsoluteUrl('/media/logo/logo.png')}
						style={{ maxHeight: 56, maxWidth: 220 }}
					/>
				</Link>
				<Link to="/auth/login" className="btn btn-primary font-weight-bold">
					Iniciar sesión
				</Link>
			</div>
			<div className="container-fluid py-8 flex-grow-1">{children}</div>
		</div>
	)
}

export function LegalTextPage({ textId }) {
	const isLogged = useSelector((store) => store.authentication?.loggedIn, shallowEqual)
	const body = <LegalTextBody textId={textId} />

	if (isLogged) {
		return <Layout hideSubheader>{body}</Layout>
	}

	return <PublicLegalShell>{body}</PublicLegalShell>
}
